module.exports = __webpack_public_path__ + "static/media/MAXMRJ-Logo-1.35b39f7a.png";